const LegendaPoloGerador = () => {

  return (
    <div>
      <table className="table table-striped table-condensed legenda-mapa">
        <thead>
          <tr>
            <th colSpan="2" style={{ paddingBottom: 7 }}>
              <span
                className="font-weight-bold text-center"
                style={{ color: 'rgb(0, 72, 14)', fontSize: 16 }}
              >
                LEGENDA POLOS GERADORES
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          {[
            { src: '/img/polos_geradores/grupos/alimentacao.png', label: 'Alimentação' },
            { src: '/img/polos_geradores/grupos/automotivo.png', label: 'Automotivo' },
            { src: '/img/polos_geradores/grupos/decoracao.png', label: 'Decoração' },
            { src: '/img/polos_geradores/grupos/educacao.png', label: 'Educação' },
            { src: '/img/polos_geradores/grupos/financeira.png', label: 'Instituição Financeira' },
            { src: '/img/polos_geradores/grupos/moda.png', label: 'Moda' },
            { src: '/img/polos_geradores/grupos/outros.png', label: 'Outros' },
            { src: '/img/polos_geradores/grupos/saude.png', label: 'Saúde e Bem-Estar' },
            { src: '/img/polos_geradores/grupos/servicos.png', label: 'Serviços' },
            { src: '/img/polos_geradores/grupos/shopping-center-2.png', label: 'Shopping Center' },
            { src: '/img/polos_geradores/grupos/construcao-e-bricolagem.png', label: 'Loja De Materiais De Construção' },

          ].map(({ src, label }) => (
            <tr key={label}>
              <td>
                <img src={src} alt={label} width={30} height={34} />
              </td>
              <td>{label}</td>
            </tr>
          ))}
        </tbody>
      </table>

    </div>
  );
};

export default LegendaPoloGerador;
